import AdsApi, { EXPORTS } from '../api/ads';
import {
  AdAccountFilter, AdSetFilter, CampaignFilter, DEFAULT_SITE, SiteFilter, StatusFilter,
} from '../components/ads/AdFilters';
import { METRIC_COLUMNS, Mono, NameCell, StatusChip } from '../components/ads/cells';
import LinkCell from '../components/table/LinkCell';
import ListPage from '../components/table/ListPage';

const DEFAULTS = { site: DEFAULT_SITE, ordering: '-spend' };

const COLUMNS = [
  {
    id: 'name', label: 'Ad',
    render: (row) => <NameCell name={row.name} secondary={`${row.campaign_name} › ${row.adset_name}`} />,
  },
  { id: 'effective_status', label: 'Status', render: (row) => <StatusChip row={row} /> },
  { id: 'utm_id', label: 'utm_id', render: (row) => <Mono>{row.utm_id}</Mono> },
  // the ad set's targeting locales as Facebook names them; — when Facebook returns none
  { id: 'language', label: 'Language', sort: false },
  {
    id: 'link_url_combined', label: 'Landing page', sort: false,
    render: (row) => <LinkCell href={row.link_url_combined} />,
  },
  ...METRIC_COLUMNS,
];

export default function Ads() {
  return (
    <ListPage
      exportPath={EXPORTS.ads}
      title="Ads" description="Every ad with its landing page, utm_id and language for the trial reports."
      fetchList={AdsApi.ads} defaults={DEFAULTS} columns={COLUMNS} minWidth={1300}
      emptyTitle="No ads yet" emptyHint="Enable an ad account and run a sync to see its ads."
      searchPlaceholder="Search name, utm_id or URL"
      filters={({ query, setQuery }) => (
        <>
          <SiteFilter query={query} setQuery={setQuery} />
          <StatusFilter query={query} setQuery={setQuery} />
          <AdAccountFilter query={query} setQuery={setQuery} />
          <CampaignFilter query={query} setQuery={setQuery} />
          <AdSetFilter query={query} setQuery={setQuery} />
        </>
      )}
    />
  );
}
